'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$State) {
  _inherits(_class, _Phaser$State);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {}
  }, {
    key: 'preload',
    value: function preload() {

      /* BANNER */
      var bannerText = 'Bubble "Dot" Game';
      var banner = this.add.text(this.world.centerX, this.world.centerY - 80, bannerText, {
        font: 'bold 35px Arial',
        fill: '#FFF',
        smoothed: false
      });
      banner.padding.set(10, 16);
      banner.anchor.setTo(0.5);

      /* ASSETS */
      this.load.spritesheet('bubble', 'assets/images/bubble.png', 400, 400, 12);
      this.load.spritesheet('button', 'assets/images/button.png', 190, 49, 2);
      this.load.audio('popSound', 'assets/audio/dustyroom_cartoon_bubble_pop.mp3');
      this.load.image('greySlider', 'assets/images/grey_sliderHorizontal.png');
      this.load.image('greySliderEnd', 'assets/images/grey_sliderEnd.png');
      this.load.image('greySliderDown', 'assets/images/grey_sliderDown.png');
    }
  }, {
    key: 'create',
    value: function create() {

      this.startButton = this.game.add.sprite(this.game.world.centerX, this.game.world.centerY, 'button');
      this.startButton.inputEnabled = true;

      this.startButton.events.onInputUp.add(function (e) {
        game.paused = false;
        e.game.state.start('Game');
      });
      this.startButton.anchor.setTo(0.5);

      this.startButtonText = game.add.text(this.game.world.centerX, this.game.world.centerY, "Start", {
        font: "30px Arial",
        fill: "#FFF"
      });
      this.startButtonText.anchor.setTo(0.5);
    }
  }]);

  return _class;
}(_phaser2.default.State);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/states/Splash.js
// module id = 339
// module chunks = 0